/**
 * Stránka pro vytvoreni archivni entity.
 */

import { refApTypesFetchIfNeeded } from 'actions/refTables/apTypes';
import { descItemTypesFetchIfNeeded } from "actions/refTables/descItemTypes";
import { refPartTypesFetchIfNeeded } from "actions/refTables/partTypes";
import { refRulDataTypesFetchIfNeeded } from "actions/refTables/rulDataTypes";
import { requestScopesIfNeeded } from "actions/refTables/scopesData";
import { ApAccessPointCreateVO } from 'api/ApAccessPointCreateVO';
import React, { FC, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { WebApi } from '../../actions';
import CreateAccessPointModal, { CreateAccessPointModalFields } from '../../components/registry/modal/CreateAccessPointModal';
import {} from '../../components/shared';
import { defineMessages, useIntl } from 'react-intl';

// Id je převzaté z legacy katalogu beze změny.
const messages = defineMessages({
    addRegistry: { id: 'registry.addRegistry', defaultMessage: 'Nová archivní entita' },
});
import { AP_VIEW_SETTINGS } from '../../constants';
import { DetailActions } from '../../shared/detail';
import PageLayout from "../shared/layout/PageLayout";
import './EntityCreatePage.scss';
import { ApAccessPointVO } from 'api';
import { ApItemVO } from 'api/ApItemVO';
import { useThunkDispatch } from 'utils/hooks/useThunkDispatch.js';

const serverContextPath: string | undefined = (window as any).serverContextPath;

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

enum ResponseStatus {
    SUCCESS = "SUCCESS",
    CANCEL = "CANCEL",
}

const replaceStrings = (
    string: string,
    replaceArray: Array<[string, string]>
) => {
    let newString = string;
    replaceArray.forEach((replace)=>{ newString = newString.replace(replace[0], replace[1]) })
    return newString;
}

export const EntityCreatePage:FC = () => {
    const intl = useIntl();
    const dispatch = useThunkDispatch();
    const query = useQuery();
    const responseUrl = query.get("response");
    const entityClass = query.get("entity-class");
    const entityClasses = entityClass ? entityClass.split(",") : [];

    const handleSubmit = async (formData: CreateAccessPointModalFields) => {
        if (!formData.partForm) {
            return Promise.reject("");
        }

        const items:ApItemVO[] = [];

        formData.partForm.items.forEach(({updatedItem}) => {
            if(updatedItem){
                items.push(updatedItem);
            }
        });

        const submitData:ApAccessPointCreateVO = {
            partForm: {...formData.partForm, items},
            scopeId: formData.scopeId,
            typeId: formData.apType.id,
        };

        const entity = await WebApi.createAccessPoint(submitData);
        location.assign(getResponseUrl(ResponseStatus.SUCCESS, entity));
    }

    const handleDialogClose = () => {
        location.assign(getResponseUrl(ResponseStatus.CANCEL))
    }

    const getEntityUrl = () => {
        return `${serverContextPath}/entity/{entityId}`;
    }

    const getResponseUrl = (
        status: ResponseStatus,
        entity?: ApAccessPointVO
    ) => {
        return replaceStrings(responseUrl || getEntityUrl() || location.href, [
            ["{status}", status],
            ["{entityUuid}", entity?.id ? entity.uuid : ""],
            ["{entityId}", entity?.id ? entity.id.toString() : ""]
        ]);
    }



    useEffect(()=>{
            dispatch(fetchApTypeViewIfNeeded());
            dispatch(refApTypesFetchIfNeeded());
            dispatch(refPartTypesFetchIfNeeded());
            dispatch(requestScopesIfNeeded());
            dispatch(descItemTypesFetchIfNeeded());
            dispatch(refRulDataTypesFetchIfNeeded());
    },[dispatch]);

    return (
        <>
            <PageLayout
                className='entity-create-page'
                centerPanel={<div/>}
            />
            <CreateAccessPointModal
                title={intl.formatMessage(messages.addRegistry)}
                onSubmit={handleSubmit}
                onClose={handleDialogClose}
                apTypeFilter={entityClasses}
            />
        </>
    )
}

const fetchApTypeViewIfNeeded = () => {
    return DetailActions.fetchIfNeeded(AP_VIEW_SETTINGS, '', () => {
        return WebApi.getApTypeViewSettings();
    })
}
